import BuilderPage from './BuilderPage';

export default BuilderPage;
